<template>
    <div class="preloader-overlay" v-show="preloadShow">
        <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <RouterView v-slot="{ Component }">
        <transition
            enter-active-class="animate__animated animate__fadeIn"
            leave-active-class="animate__animated animate__fadeOut"
            mode="out-in"
        >
            <component :is="Component" />
        </transition>
    </RouterView>

    <LogoutPopupDisplay :isVisible="showLogout" @close="showLogout = false" :general="false" />
</template>

<script setup>
import "bootstrap/dist/css/bootstrap.css"
import "./assets/css/style.css"
import "animate.css"
import "bootstrap/dist/js/bootstrap.bundle.js"
import "bootstrap-icons/font/bootstrap-icons.css"
import Swal from "sweetalert2"
import LogoutPopupDisplay from "./components/display/LogoutPopupDisplay.vue"

import { RouterView } from "vue-router"

import { onMounted, onUnmounted, ref } from "vue"
import { storeToRefs } from "pinia"
import { useAuthStore } from "./store/auth"
import { usePreloadStore } from "./store/preload"

const showLogout = ref(false)
const preloadStore = usePreloadStore()
const { show: preloadShow } = storeToRefs(preloadStore)

const authStore = useAuthStore()
var cekIsUserLoggedIn = (e) => {
    authStore.checkAuth()
    let currentUser = authStore.getCurrentUser()
    if (currentUser != null) {
        e.preventDefault()
        showLogout.value = true
        e.returnValue = ""
    }
}

// onMounted(() => {
//     window.addEventListener("beforeunload", cekIsUserLoggedIn)
// })

// onUnmounted(() => {
//     window.removeEventListener("beforeunload", cekIsUserLoggedIn)
// })
</script>

<style>
@import "vidstack/player/styles/default/theme.css";
@import "vidstack/player/styles/default/layouts/audio.css";
@import "vidstack/player/styles/default/layouts/video.css";

/* CSS-RESET: https://www.joshwcomeau.com/css/custom-css-reset/ */
*,
*::before,
*::after {
    box-sizing: border-box;
}

* {
    margin: 0;
}

/* width */
::-webkit-scrollbar {
    width: 4px;
    margin: 20px;
}

/* Track */
::-webkit-scrollbar-track {
    border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #676767;
    border-radius: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #474747;
}

html,
body {
    height: 100%;
}

body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
    display: block;
    max-width: 100%;
}

input,
button,
textarea,
select {
    font: inherit;
}

/* /CSS-RESET */

@font-face {
    font-family: Komika;
    src: url("./assets/fonts/komika-regular.woff") format("woff");
}

body {
    font-family: Tahoma, Verdana, sans-serif;
    overflow-x: auto;
    _overflow: hidden;
    image-rendering: optimizeQuality;
}

.comic {
    font-family: Komika, Tahoma, Verdana, sans-serif;
}

a {
    color: black;
    text-decoration: none;
}

a:hover {
    color: black;
    text-decoration: none;
}

.preloader-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
